import { put } from "redux-saga/effects";

import actions from "@/actions";
import * as MarkerService from "@/services/marker";

/**
 * Fetches marker positions for a floor space and dispatches them to the store.
 *
 * @param root0 - The configuration options.
 * @param root0.floorSpaceId - The floor space ID to fetch markers for.
 * @yields Calls the marker service and dispatches setMarkers.
 */
function* loadMarkers({ floorSpaceId }) {
    const markers = yield MarkerService.getByFloorSpaceId(floorSpaceId);

    const markersById = {};

    for (const marker of markers) {
        markersById[marker.uniqueId] = marker;
    }

    yield put(actions.map.values.global.setMarkers(markersById));
}

export default loadMarkers;
